// extracted by mini-css-extract-plugin
export default {"root":"OfferImage_root__IzZll"};